export const durationList = [
  { label: "Current month" },
  { label: "Last month" },
  { label: "Last three months" },
  { label: "Last six months" },
  { label: "Last year" },
  { label: "Current year" },
  { label: "Custom date" },
];

export const menuItems = [
  {
    key: "1",
    label: "Annadanam",
  },
  {
    key: "2",
    label: "Festival",
  },
];

export const donationsTypeList = [
  { value: "1", label: "Annadanam" },
  { value: "2", label: "Festival" },
];
